import React from 'react'
import PropTypes from 'prop-types'
import Add from '@mui/icons-material/Add'

const AddIcon = ({ height, width, ...more }) => {
	
	return (
		<Add
			height={height}
			width={width}
			{...more}
		/>
	)
}

AddIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default AddIcon
